import { TestimonialCard } from 'components/Testimonials'
import { useBlogPostsQuery } from 'hooks/useBlogPostsQuery'
import Link from 'next/link'
import { ComponentType } from 'react'
import { GoChevronRight } from 'react-icons/go'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { AgentCard } from 'views/agents/agent-card'

const Wrapper = styled.div`
  padding: 44px 0;
`

const Title = styled.h5`
  padding-left: 16px;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
`

const AgentCardWrapper = styled.div`
  padding: 22px 0;
`

const GoToTestimonials = styled.div`
  padding-top: 24px;
  text-align: center;
`

interface Props {
  agents: any[]
}

export const SalesDesktop: ComponentType<Props> = ({ agents }) => {
  const { data } = useBlogPostsQuery({
    variables: { query: { limit: 1, filter: 'tag:testimonios' } },
  })

  const testimonial = data?.blogPosts.posts[0]

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Title>Equipo de Ventas</Title>
          </Col>
        </Row>
        <div className="five-big-row">
          {agents.map(agent => (
            <div key={agent.uuid} className="five-big-col-1">
              <AgentCardWrapper>
                <AgentCard agent={agent} />
              </AgentCardWrapper>
            </div>
          ))}
        </div>

        {/* <div className="five-big-row">
          <div className="five-big-col-3">
            <div className="five-big-row">
              {agents.slice(0, 6).map((agent: any) => (
                <div key={agent.uuid} className="five-big-col" style={{ maxWidth: 'calc(100% / 3)' }}>
                  <AgentCardWrapper>
                    <AgentCard agent={agent} />
                  </AgentCardWrapper>
                </div>
              ))}
            </div>
          </div> */}
        {/* <div className="five-big-col-2">
            {testimonial && <TestimonialCard testimonial={testimonial} expanded />}
            <GoToTestimonials>
              <Link href="/acerca/testimoniales">
                <a title="Conoce más testimoniales">
                  Conoce más testimoniales <GoChevronRight />
                </a>
              </Link>
            </GoToTestimonials>
          </div> */}
        {/* </div>
        <div className="five-big-row">
          {agents.slice(6, agents.length).map((agent: any) => (
            <div key={agent.uuid} className="five-big-col-1">
              <AgentCard agent={agent} />
            </div>
          ))}
        </div> */}
      </Container>
    </Wrapper>
  )
}
